function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 1,
  width: 20,
  height: 7.33333,
  rx: 0.666667,
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 5.16667C13.2761 5.16667 13.5 4.94281 13.5 4.66667C13.5 4.39053 13.2761 4.16667 13 4.16667V5.16667ZM6.5 4.66667C6.5 4.99937 6.27084 5.21429 6 5.21429V6.21429C6.88176 6.21429 7.5 5.49113 7.5 4.66667H6.5ZM6 5.21429C5.72916 5.21429 5.5 4.99937 5.5 4.66667H4.5C4.5 5.49113 5.11824 6.21429 6 6.21429V5.21429ZM5.5 4.66667C5.5 4.33397 5.72916 4.11905 6 4.11905V3.11905C5.11824 3.11905 4.5 3.8422 4.5 4.66667H5.5ZM6 4.11905C6.27084 4.11905 6.5 4.33397 6.5 4.66667H7.5C7.5 3.8422 6.88176 3.11905 6 3.11905V4.11905ZM7 5.16667H13V4.16667H7V5.16667Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 4.66666C16 4.95595 15.7761 5.19047 15.5 5.19047C15.2239 5.19047 15 4.95595 15 4.66666C15 4.37737 15.2239 4.14285 15.5 4.14285C15.7761 4.14285 16 4.37737 16 4.66666Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18 4.66666C18 4.95595 17.7761 5.19047 17.5 5.19047C17.2239 5.19047 17 4.95595 17 4.66666C17 4.37737 17.2239 4.14285 17.5 4.14285C17.7761 4.14285 18 4.37737 18 4.66666Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.66666C20 4.95595 19.7761 5.19047 19.5 5.19047C19.2239 5.19047 19 4.95595 19 4.66666C19 4.37737 19.2239 4.14285 19.5 4.14285C19.7761 4.14285 20 4.37737 20 4.66666Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 8.33334,
  width: 20,
  height: 7.33333,
  rx: 0.666667,
  stroke: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13 12.5C13.2761 12.5 13.5 12.2762 13.5 12C13.5 11.7239 13.2761 11.5 13 11.5V12.5ZM6.5 12C6.5 12.3327 6.27084 12.5476 6 12.5476V13.5476C6.88176 13.5476 7.5 12.8245 7.5 12H6.5ZM6 12.5476C5.72916 12.5476 5.5 12.3327 5.5 12H4.5C4.5 12.8245 5.11824 13.5476 6 13.5476V12.5476ZM5.5 12C5.5 11.6673 5.72916 11.4524 6 11.4524V10.4524C5.11824 10.4524 4.5 11.1755 4.5 12H5.5ZM6 11.4524C6.27084 11.4524 6.5 11.6673 6.5 12H7.5C7.5 11.1755 6.88176 10.4524 6 10.4524V11.4524ZM7 12.5H13V11.5H7V12.5Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16 12C16 12.2893 15.7761 12.5238 15.5 12.5238C15.2239 12.5238 15 12.2893 15 12C15 11.7107 15.2239 11.4762 15.5 11.4762C15.7761 11.4762 16 11.7107 16 12Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18 12C18 12.2893 17.7761 12.5238 17.5 12.5238C17.2239 12.5238 17 12.2893 17 12C17 11.7107 17.2239 11.4762 17.5 11.4762C17.7761 11.4762 18 11.7107 18 12Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M20 12C20 12.2893 19.7761 12.5238 19.5 12.5238C19.2239 12.5238 19 12.2893 19 12C19 11.7107 19.2239 11.4762 19.5 11.4762C19.7761 11.4762 20 11.7107 20 12Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 15.6667,
  width: 20,
  height: 7.33333,
  rx: 0.666667,
  stroke: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M13 19.8333C13.2761 19.8333 13.5 19.6095 13.5 19.3333C13.5 19.0572 13.2761 18.8333 13 18.8333V19.8333ZM6.5 19.3333C6.5 19.666 6.27084 19.8809 6 19.8809V20.8809C6.88176 20.8809 7.5 20.1578 7.5 19.3333H6.5ZM6 19.8809C5.72916 19.8809 5.5 19.666 5.5 19.3333H4.5C4.5 20.1578 5.11824 20.8809 6 20.8809V19.8809ZM5.5 19.3333C5.5 19.0006 5.72916 18.7857 6 18.7857V17.7857C5.11824 17.7857 4.5 18.5089 4.5 19.3333H5.5ZM6 18.7857C6.27084 18.7857 6.5 19.0006 6.5 19.3333H7.5C7.5 18.5089 6.88176 17.7857 6 17.7857V18.7857ZM7 19.8333H13V18.8333H7V19.8333Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M16 19.3333C16 19.6226 15.7761 19.8571 15.5 19.8571C15.2239 19.8571 15 19.6226 15 19.3333C15 19.044 15.2239 18.8095 15.5 18.8095C15.7761 18.8095 16 19.044 16 19.3333Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M18 19.3333C18 19.6226 17.7761 19.8571 17.5 19.8571C17.2239 19.8571 17 19.6226 17 19.3333C17 19.044 17.2239 18.8095 17.5 18.8095C17.7761 18.8095 18 19.044 18 19.3333Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M20 19.3333C20 19.6226 19.7761 19.8571 19.5 19.8571C19.2239 19.8571 19 19.6226 19 19.3333C19 19.044 19.2239 18.8095 19.5 18.8095C19.7761 18.8095 20 19.044 20 19.3333Z",
  fill: "white"
});

var SvgHostIssues = function SvgHostIssues(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHostIssues, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/host-issues.ccd90c22.svg";
export { ForwardRef as ReactComponent };